// extracted by mini-css-extract-plugin
export default {"container":"LoadingModal-module__container___LuIdf","messageBox":"LoadingModal-module__messageBox___nKZS0","textBold":"LoadingModal-module__textBold___X0p_v"};